export default {
  teams (state) {
    return {
      ...state,
      storeName: 'teams'
    }
  }
}
